<template>
  <div class="p-6">
    <formulate-form name="dataform" @submit="formHandler" class="grid gap-4">
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/6">
          <span>Dni</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <formulate-input
            type="text"
            name="Dni"
            help="1331929830"
            class="md:w-7/12 w-full"
            v-model="numberId"
            validation="required"
          />
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/6">
          <span>Nombre</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <formulate-input
            class="md:w-7/12 w-full"
            autocomplete="off"
            help="Andres Perez"
            name="Nombre"
            v-model="names"
            validation="required"
          />
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/6">
          <span>Correo</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <formulate-input
            class="md:w-7/12 w-full"
            autocomplete="off"
            help="mail@exemple.com"
            name="Correo"
            v-model="email"
            validation="required|email"
          />
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/6">
          <span>Rol</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <v-select
            class="style-chooser md:w-7/12 w-full"
            :options="roles"
            :reduce="(tr) => tr.roleId"
            label="roleName"
            v-model="usr_role"
          ></v-select>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/6">
          <span>Empresa</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <v-select
            class="style-chooser md:w-7/12 w-full"
            :options="empresas"
            :reduce="(tr) => tr.com_id"
            label="com_name"
            v-model="com_id"
          ></v-select>
        </div>
      </div>
      <div class="vx-row flex justify-center">
        <div class="vx-col md:w-1/3 w-full grid grid-cols-2 gap-4">
          <vs-button
            color="#EE9436"
            icon-pack="feather"
            icon="icon-save"
            @click="saveform"
            ref="loadableButton"
            id="button-with-loading"
            class="vs-con-loading__container"
            >Grabar</vs-button
          >
          <vs-button
            color="#EE9436"
            icon-pack="feather"
            icon="icon-arrow-left"
            @click="go_back"
            >Regresar</vs-button
          >
        </div>
      </div>
    </formulate-form>
  </div>
</template>

<script>
export default {
  name: "new",

  data() {
    return {};
  },

  mounted() {
    this.$store.dispatch("lists/getListRol");
    this.$store.dispatch("lists/getListEmpresa");
  },

  computed: {
    roles: {
      get() {
        return this.$store.state.lists.table_rol || null;
      },
      set(val) {
        this.$store.commit("user/set_rol", val);
      },
    },
    empresas: {
      get() {
        return this.$store.state.lists.table_empresa || null;
      },
      set(val) {
        this.$store.commit("user/set_empresa", val);
      },
    },
    names: {
      get() {
        return this.$store.state.user.names || null;
      },
      set(val) {
        this.$store.commit("user/set_name", val);
      },
    },
    email: {
      get() {
        return this.$store.state.user.email || null;
      },
      set(val) {
        this.$store.commit("user/set_email", val);
      },
    },
    password: {
      get() {
        return this.$store.state.user.password || null;
      },
      set(val) {
        this.$store.commit("user/set_password", val);
      },
    },
    passconf: {
      get() {
        return this.$store.state.user.passconf || null;
      },
      set(val) {
        this.$store.commit("user/set_passconf", val);
      },
    },
    usr_role: {
      get() {
        return this.$store.state.user.usr_role || null;
      },
      set(val) {
        this.$store.commit("user/set_rol", val);
      },
    },
    com_id: {
      get() {
        return this.$store.state.user.com_id || null;
      },
      set(val) {
        this.$store.commit("user/com_id", val);
      },
    },
    numberId: {
      get() {
        return this.$store.state.user.numberId || null;
      },
      set(val) {
        this.$store.commit("user/set_numberId", val);
      },
    },
  },

  methods: {
    go_back() {
      let display = {
        table: true,
        add: false,
        edit: false,
      };
      this.$emit("screen", display);
    },
    saveform() {
      this.$formulate.submit("dataform");
    },
    async formHandler() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45,
      });
      try {
        await this.$store.dispatch("user/setUser", this.$store.state.user);
        this.$vs.notify({
          title: "Success",
          text: "Guardado",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        let display = {
          table: true,
          add: false,
          edit: false,
        };
        this.$emit("screen", display);
      } catch (error) {
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
      }
    },
  },
};
</script>
<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  box-shadow: 10px 0 10px 0;
  /* height: 40px; */
  border: none;
  text-transform: lowercase;
  font-variant: small-caps;
  color: #cbcfda;
  font-size: 18px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.15);
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #cbcfda;
  height: 35px;
  border-radius: 10px;
}
</style>
